export default (state, { payload: { showWarningBanner } }) => ({
  ...state,
  showWarningBanner
});
